import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Line, Doughnut } from "react-chartjs-2";
import {
  FiTrendingUp,
  FiShoppingBag,
  FiCheckCircle,
  FiActivity,
  FiClock,
  FiChevronDown,
  FiSearch,
  FiAward,
  FiBox,
  FiArrowUpRight,
  FiArrowDownRight,
  FiPlusCircle,
  FiUserCheck,
  FiCalendar,
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiLayers,
  FiRefreshCw
} from "react-icons/fi";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
);

const DashboardPage = () => {
  // State untuk best selling product
  const [bestSellingData, setBestSellingData] = useState(null);
  const [period, setPeriod] = useState("yearly");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const outlet_id = role === "manager" ? localStorage.getItem("outlet_id") : null;

  const [totalOrder, setTotalOrder] = useState(null);
  const [successfulOrders, setSuccessfulOrders] = useState(null);
  const [income, setIncome] = useState(null);
  const [weeklyChartData, setWeeklyChartData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [logObatData, setLogObatData] = useState([]);
  
  const [logPage, setLogPage] = useState(1);
  const [logObatPage, setLogObatPage] = useState(1);
  const [logSearch, setLogSearch] = useState("");
  const [logObatSearch, setLogObatSearch] = useState("");
  const logPerPage = 5;

  // Helper salam berdasarkan jam
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Selamat Pagi";
    if (hour < 15) return "Selamat Siang";
    if (hour < 18) return "Selamat Sore";
    return "Selamat Malam";
  };

  useEffect(() => {
    const fetchBestSelling = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/analytics/best-selling/${period}${
          outlet_id ? `?outlet_id=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setBestSellingData(res.data.data || null);
      } catch (err) {
        console.error("Gagal memuat data obat terlaris:", err);
        setBestSellingData(null);
      }
    };

    fetchBestSelling();
  }, [period, outlet_id, token]);

  useEffect(() => {
    const fetchTotalOrder = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/analytics/total-amount${
          outlet_id ? `?outlet_id=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTotalOrder(res.data.data || null);
      } catch (err) {
        console.error("Gagal memuat total pemesanan:", err);
        setTotalOrder(null);
      }
    };

    fetchTotalOrder();
  }, [outlet_id, token]);

  useEffect(() => {
    const fetchSuccessfulOrders = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/analytics/total-transaction${
          outlet_id ? `?outlet_id=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSuccessfulOrders(res.data.data || null);
      } catch (err) {
        console.error("Gagal memuat pemesanan berhasil:", err);
        setSuccessfulOrders(null);
      }
    };

    fetchSuccessfulOrders();
  }, [outlet_id, token]);

  useEffect(() => {
    const fetchIncome = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/analytics/income${
          outlet_id ? `?outlet_id=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setIncome(res.data.data || null);
      } catch (err) {
        console.error("Gagal memuat total pendapatan:", err);
        setIncome(null);
      }
    };

    fetchIncome();
  }, [outlet_id, token]);

  useEffect(() => {
    const fetchWeeklyChart = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/analytics/chart-income-weekly${
          outlet_id ? `?outlet_id=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWeeklyChartData(Array.isArray(res.data.data) ? res.data.data : []);
      } catch (err) {
        console.error("Gagal memuat data chart pendapatan mingguan:", err);
        setWeeklyChartData([]);
      }
    };

    fetchWeeklyChart();
  }, [outlet_id, token]);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/logs${
          outlet_id ? `?id_outlet=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLogData(res.data.data || []);
      } catch (err) {
        console.error("Gagal mengambil log:", err);
      }
    };

    const fetchLogObat = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/v1/logs/obat${
          outlet_id ? `?id_outlet=${outlet_id}` : ""
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLogObatData(res.data.data || []);
      } catch (err) {
        console.error("Gagal mengambil log obat:", err);
      }
    };

    fetchLogs();
    fetchLogObat();
  }, [outlet_id, token]);

  // Filter logs berdasarkan keyword pencarian
  const filteredLogs = logData.filter((log) => {
    if (!logSearch.trim()) return true;
    const term = logSearch.toLowerCase();
    const msg = (log.message || "").toLowerCase();
    const ref = (log.ref?.code || "").toLowerCase();
    return msg.includes(term) || ref.includes(term);
  });

  const filteredLogObat = logObatData.filter((log) => {
    if (!logObatSearch.trim()) return true;
    const term = logObatSearch.toLowerCase();
    const msg = (log.message || "").toLowerCase();
    const obat = (log.obat?.name || "").toLowerCase();
    return msg.includes(term) || obat.includes(term);
  });

  const paginate = (data, page) => {
    const start = (page - 1) * logPerPage;
    return data.slice(start, start + logPerPage);
  };

  // Configuration for Charts
  const weeklyChartConfig = {
    labels:
      weeklyChartData.length > 0
        ? weeklyChartData.map((item) => item.day)
        : ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"],
    datasets: [
      {
        label: "Minggu Ini",
        data:
          weeklyChartData.length > 0
            ? weeklyChartData.map((item) => item.amount_this_week)
            : [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgba(16, 185, 129, 0.12)",
        borderColor: "#10B981",
        pointBackgroundColor: "#10B981",
        pointBorderColor: "#FFFFFF",
        pointHoverBackgroundColor: "#FFFFFF",
        pointHoverBorderColor: "#10B981",
        pointRadius: 4,
        pointHoverRadius: 6,
        fill: true,
        tension: 0.4,
      },
      {
        label: "Minggu Lalu",
        data:
          weeklyChartData.length > 0
            ? weeklyChartData.map((item) => item.amount_last_week)
            : [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: "rgba(99, 102, 241, 0.06)",
        borderColor: "#6366F1",
        pointBackgroundColor: "#6366F1",
        pointBorderColor: "#FFFFFF",
        pointHoverBackgroundColor: "#FFFFFF",
        pointHoverBorderColor: "#6366F1",
        pointRadius: 4,
        pointHoverRadius: 6,
        borderDash: [4, 4],
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 8,
          boxHeight: 8,
          padding: 16,
          font: {
            size: 12,
            weight: "600",
          },
          color: "#4B5563",
        },
      },
      tooltip: {
        backgroundColor: "rgba(17, 24, 39, 0.9)",
        titleFont: { size: 13, weight: "700" },
        bodyFont: { size: 12 },
        padding: 12,
        cornerRadius: 12,
        displayColors: true,
        callbacks: {
          label: (context) =>
            ` ${context.dataset.label}: Rp ${Number(context.raw).toLocaleString(
              "id-ID"
            )}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#9CA3AF", font: { size: 11 } },
      },
      y: {
        grid: { color: "#F3F4F6" },
        ticks: {
          color: "#9CA3AF",
          font: { size: 11 },
          callback: (val) => `Rp ${(val / 1000).toLocaleString("id-ID")}k`,
        },
      },
    },
  };

  const pieData = {
    labels: ["Obat Bebas", "Resep Dokter", "Alat Kesehatan"],
    datasets: [
      {
        label: "Statistik Pemesanan",
        data: [45, 30, 25],
        backgroundColor: ["#10B981", "#3B82F6", "#F59E0B"],
        borderWidth: 3,
        borderColor: "#FFFFFF",
        hoverOffset: 6,
      },
    ],
  };

  const revenuePieData = {
    labels: ["Obat Bebas", "Resep Dokter", "Alat Kesehatan"],
    datasets: [
      {
        label: "Statistik Pendapatan",
        data: [55, 25, 20],
        backgroundColor: ["#06B6D4", "#8B5CF6", "#EC4899"],
        borderWidth: 3,
        borderColor: "#FFFFFF",
        hoverOffset: 6,
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "72%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 8,
          padding: 14,
          font: { size: 11, weight: "500" },
          color: "#4B5563",
        },
      },
      tooltip: {
        backgroundColor: "rgba(17, 24, 39, 0.9)",
        cornerRadius: 10,
        padding: 10,
      },
    },
  };

  return (
    <div className="min-h-screen bg-gray-50/50 p-2 md:p-6 space-y-8">
      {/* 1. HERO BANNER & BEST SELLER */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="grid grid-cols-1 lg:grid-cols-3 gap-6"
      >
        {/* Welcome Card */}
        <div className="lg:col-span-2 relative overflow-hidden rounded-3xl bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-700 p-6 md:p-8 text-white shadow-xl shadow-teal-900/10">
          {/* Subtle Glow Accents */}
          <div className="absolute -right-10 -bottom-10 w-64 h-64 bg-white/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute right-40 -top-10 w-40 h-40 bg-teal-400/20 rounded-full blur-xl pointer-events-none" />

          <div className="relative z-10 flex flex-col justify-between h-full min-h-[170px]">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur-md text-white/90 text-xs font-medium mb-3 border border-white/20">
                <FiClock className="w-3.5 h-3.5" />
                <span>{getGreeting()}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                <span>Sistem Operasional Aktif</span>
              </div>
              <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight text-white mb-2">
                Hai, {localStorage.getItem("full_name") || "Pengguna"} 👋
              </h1>
              <p className="text-teal-100 text-sm md:text-base max-w-xl font-normal leading-relaxed">
                Selamat datang di Dashboard Djaya Medika. Semua aktivitas dan performa penjualan outlet terantau real-time.
              </p>
            </div>

            {/* Quick Action CTAs */}
            <div className="flex flex-wrap items-center gap-3 mt-6">
              <Link to="/transactions">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="inline-flex items-center gap-2 bg-white text-emerald-700 font-semibold px-5 py-2.5 rounded-xl shadow-lg hover:shadow-xl hover:bg-emerald-50 transition-all duration-200 text-sm"
                >
                  <FiPlusCircle className="w-4 h-4 text-emerald-600" />
                  <span>Transaksi Penjualan</span>
                </motion.button>
              </Link>
              <Link to="/enterprise/karyawan">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="inline-flex items-center gap-2 bg-emerald-800/40 hover:bg-emerald-800/60 backdrop-blur-md text-white border border-white/20 font-medium px-4 py-2.5 rounded-xl transition-all duration-200 text-sm"
                >
                  <FiUserCheck className="w-4 h-4" />
                  <span>Shift Karyawan</span>
                </motion.button>
              </Link>
            </div>
          </div>
        </div>

        {/* Best Selling Product Card */}
        <div className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 flex flex-col justify-between">
          <div>
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <div className="p-2.5 rounded-2xl bg-amber-50 text-amber-600 border border-amber-100">
                  <FiAward className="w-5 h-5" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">Obat Terlaris</h3>
              </div>

              {/* Period Dropdown Filter */}
              <div className="relative">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 hover:bg-gray-200/80 text-gray-700 text-xs font-semibold rounded-xl transition-colors"
                >
                  <span>
                    {period === "weekly"
                      ? "Mingguan"
                      : period === "monthly"
                      ? "Bulanan"
                      : "Tahunan"}
                  </span>
                  <FiChevronDown
                    className={`w-3.5 h-3.5 transition-transform duration-200 ${
                      dropdownOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <AnimatePresence>
                  {dropdownOpen && (
                    <motion.ul
                      initial={{ opacity: 0, y: 5, scale: 0.95 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: 5, scale: 0.95 }}
                      className="absolute right-0 mt-2 bg-white shadow-xl rounded-2xl p-1.5 z-20 w-36 border border-gray-100 text-xs"
                    >
                      {[
                        { key: "weekly", label: "Mingguan" },
                        { key: "monthly", label: "Bulanan" },
                        { key: "yearly", label: "Tahunan" },
                      ].map((item) => (
                        <li
                          key={item.key}
                          onClick={() => {
                            setPeriod(item.key);
                            setDropdownOpen(false);
                          }}
                          className={`px-3 py-2 rounded-xl cursor-pointer font-medium transition-colors ${
                            period === item.key
                              ? "bg-teal-50 text-teal-700 font-semibold"
                              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                          }`}
                        >
                          {item.label}
                        </li>
                      ))}
                    </motion.ul>
                  )}
                </AnimatePresence>
              </div>
            </div>

            {/* Best Selling Card Body */}
            {!bestSellingData ? (
              <div className="flex flex-col items-center justify-center py-8 text-gray-400 text-sm">
                <FiBox className="w-10 h-10 mb-2 stroke-1 text-gray-300" />
                <span>Tidak ada data tersedia</span>
              </div>
            ) : (
              <div className="mt-3 p-4 rounded-2xl bg-gradient-to-r from-amber-50/70 via-orange-50/40 to-amber-50/20 border border-amber-100/80">
                <div className="flex items-center gap-3.5">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 text-white font-extrabold text-lg flex items-center justify-center shadow-lg shadow-amber-500/20 flex-shrink-0">
                    🥇
                  </div>
                  <div className="flex flex-col flex-1 min-w-0">
                    <span className="text-gray-900 font-bold text-base truncate">
                      {bestSellingData.name || "Obat Terlaris"}
                    </span>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-100 text-emerald-800">
                        {bestSellingData.sale || 0} Penjualan
                      </span>
                      <span className="text-xs text-gray-400">Peringkat 1</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="mt-4 pt-3 border-t border-gray-100 flex items-center justify-between text-xs text-gray-500">
            <span>Analisis Produk Terlaris</span>
            <span className="font-semibold text-emerald-600 flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-ping" /> Realtime
            </span>
          </div>
        </div>
      </motion.div>

      {/* 2. STAT CARDS */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
      >
        {/* Card 1: Total Amount */}
        <motion.div
          whileHover={{ y: -4 }}
          className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 relative overflow-hidden transition-all duration-300"
        >
          <div className="flex justify-between items-start mb-4">
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
                Total Amount Pemesanan
              </p>
              <h2 className="text-2xl lg:text-3xl font-extrabold text-gray-900 tracking-tight">
                {totalOrder
                  ? `Rp ${Number(totalOrder.amount).toLocaleString("id-ID")}`
                  : "Memuat..."}
              </h2>
            </div>
            <div className="p-3.5 rounded-2xl bg-emerald-50 text-emerald-600 border border-emerald-100 shadow-sm flex-shrink-0">
              <FiShoppingBag className="w-6 h-6" />
            </div>
          </div>
          <div className="flex items-center gap-2">
            {totalOrder && (
              <span
                className={`inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1 rounded-full ${
                  totalOrder.percentage >= 0
                    ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                    : "bg-rose-50 text-rose-700 border border-rose-200"
                }`}
              >
                {totalOrder.percentage >= 0 ? (
                  <FiArrowUpRight className="w-3.5 h-3.5" />
                ) : (
                  <FiArrowDownRight className="w-3.5 h-3.5" />
                )}
                {Math.abs(totalOrder.percentage / 100).toFixed(2)}%
              </span>
            )}
            <span className="text-xs text-gray-400 font-medium">
              30 hari terakhir
            </span>
          </div>
        </motion.div>

        {/* Card 2: Total Transaction */}
        <motion.div
          whileHover={{ y: -4 }}
          className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 relative overflow-hidden transition-all duration-300"
        >
          <div className="flex justify-between items-start mb-4">
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
                Total Transaksi Berhasil
              </p>
              <h2 className="text-2xl lg:text-3xl font-extrabold text-gray-900 tracking-tight">
                {successfulOrders
                  ? `${Number(successfulOrders.amount).toLocaleString("id-ID")}`
                  : "Memuat..."}
              </h2>
            </div>
            <div className="p-3.5 rounded-2xl bg-blue-50 text-blue-600 border border-blue-100 shadow-sm flex-shrink-0">
              <FiCheckCircle className="w-6 h-6" />
            </div>
          </div>
          <div className="flex items-center gap-2">
            {successfulOrders && (
              <span
                className={`inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1 rounded-full ${
                  successfulOrders.percentage >= 0
                    ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                    : "bg-rose-50 text-rose-700 border border-rose-200"
                }`}
              >
                {successfulOrders.percentage >= 0 ? (
                  <FiArrowUpRight className="w-3.5 h-3.5" />
                ) : (
                  <FiArrowDownRight className="w-3.5 h-3.5" />
                )}
                {Math.abs(successfulOrders.percentage / 100).toFixed(2)}%
              </span>
            )}
            <span className="text-xs text-gray-400 font-medium">
              30 hari terakhir
            </span>
          </div>
        </motion.div>

        {/* Card 3: Total Income */}
        <motion.div
          whileHover={{ y: -4 }}
          className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 relative overflow-hidden transition-all duration-300"
        >
          <div className="flex justify-between items-start mb-4">
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
                Total Pendapatan Bersih
              </p>
              <h2 className="text-2xl lg:text-3xl font-extrabold text-gray-900 tracking-tight">
                {income
                  ? `Rp ${Math.abs(income.amount).toLocaleString("id-ID")}`
                  : "Memuat..."}
              </h2>
            </div>
            <div className="p-3.5 rounded-2xl bg-teal-50 text-teal-600 border border-teal-100 shadow-sm flex-shrink-0">
              <FiTrendingUp className="w-6 h-6" />
            </div>
          </div>
          <div className="flex items-center gap-2">
            {income && (
              <span
                className={`inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1 rounded-full ${
                  income.percentage >= 0
                    ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                    : "bg-rose-50 text-rose-700 border border-rose-200"
                }`}
              >
                {income.percentage >= 0 ? (
                  <FiArrowUpRight className="w-3.5 h-3.5" />
                ) : (
                  <FiArrowDownRight className="w-3.5 h-3.5" />
                )}
                {Math.abs(income.percentage).toFixed(2)}%
              </span>
            )}
            <span className="text-xs text-gray-400 font-medium">
              30 hari terakhir
            </span>
          </div>
        </motion.div>
      </motion.div>

      {/* 3. CHARTS SECTION */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.2 }}
        className="grid grid-cols-1 lg:grid-cols-4 gap-6"
      >
        {/* Chart 1: Pemesanan Bulanan */}
        <div className="lg:col-span-1 bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-bold text-gray-900">
                Pemesanan Bulanan
              </h3>
              <span className="text-xs font-semibold px-2.5 py-1 rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-100">
                Bulanan
              </span>
            </div>
            <div className="h-56 relative flex items-center justify-center p-2">
              <Doughnut data={pieData} options={doughnutOptions} />
            </div>
          </div>
          <div className="mt-4 pt-3 border-t border-gray-100 text-center text-xs text-gray-400">
            Kategori terlaris bulan ini
          </div>
        </div>

        {/* Chart 2: Pendapatan Bulanan */}
        <div className="lg:col-span-1 bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-bold text-gray-900">
                Pendapatan Bulanan
              </h3>
              <span className="text-xs font-semibold px-2.5 py-1 rounded-lg bg-teal-50 text-teal-700 border border-teal-100">
                Bulanan
              </span>
            </div>
            <div className="h-56 relative flex items-center justify-center p-2">
              <Doughnut data={revenuePieData} options={doughnutOptions} />
            </div>
          </div>
          <div className="mt-4 pt-3 border-t border-gray-100 text-center text-xs text-gray-400">
            Kontribusi omset per kategori
          </div>
        </div>

        {/* Chart 3: Weekly Income Line Chart */}
        <div className="lg:col-span-2 bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-bold text-gray-900">
                  Statistik Pendapatan Mingguan
                </h3>
                <p className="text-xs text-gray-500">
                  Tren perbandingan pendapatan minggu ini vs minggu lalu
                </p>
              </div>
              <div className="p-2.5 rounded-2xl bg-teal-50 text-teal-600 border border-teal-100">
                <FiActivity className="w-5 h-5" />
              </div>
            </div>
            <div className="h-64 relative">
              <Line data={weeklyChartConfig} options={lineChartOptions} />
            </div>
          </div>
        </div>
      </motion.div>

      {/* 4. LOGS & ACTIVITY SECTION */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        className="grid grid-cols-1 lg:grid-cols-2 gap-6"
      >
        {/* Log Aktivitas System */}
        <div className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 flex flex-col justify-between">
          <div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-blue-50 text-blue-600 border border-blue-100">
                  <FiFileText className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">
                    Log Aktivitas Sistem
                  </h3>
                  <p className="text-xs text-gray-400">Riwayat aksi & transaksi</p>
                </div>
              </div>

              {/* Live Search Log */}
              <div className="relative">
                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Cari log..."
                  value={logSearch}
                  onChange={(e) => {
                    setLogSearch(e.target.value);
                    setLogPage(1);
                  }}
                  className="pl-9 pr-3 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-xs text-gray-800 focus:outline-none focus:ring-2 focus:ring-teal-500/20 focus:border-teal-500 w-full sm:w-44 transition-all"
                />
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left text-xs text-gray-600">
                <thead>
                  <tr className="border-b border-gray-100 text-gray-400 font-bold uppercase tracking-wider text-[10px]">
                    <th className="pb-3 px-2">Waktu</th>
                    <th className="pb-3 px-2">Ref Kode</th>
                    <th className="pb-3 px-2">Keterangan</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {paginate(filteredLogs, logPage).length === 0 ? (
                    <tr>
                      <td
                        colSpan={3}
                        className="py-8 text-center text-gray-400 text-xs font-medium"
                      >
                        Tidak ada log aktivitas ditemukan
                      </td>
                    </tr>
                  ) : (
                    paginate(filteredLogs, logPage).map((log) => (
                      <tr
                        key={log.id}
                        className="hover:bg-teal-50/40 transition-colors"
                      >
                        <td className="py-3 px-2 text-gray-500 whitespace-nowrap">
                          {new Date(log.log_at).toLocaleString("id-ID", {
                            day: "2-digit",
                            month: "short",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                        <td className="py-3 px-2 font-bold text-gray-800 whitespace-nowrap">
                          <span className="inline-flex px-2 py-0.5 rounded-lg bg-gray-100 text-gray-700 border border-gray-200">
                            {log.ref?.code || "-"}
                          </span>
                        </td>
                        <td className="py-3 px-2 text-gray-700 max-w-xs truncate">
                          {log.message}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination Log Aktivitas */}
          <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-100 text-xs">
            <span className="text-gray-400">Halaman {logPage}</span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setLogPage((p) => Math.max(p - 1, 1))}
                disabled={logPage === 1}
                className={`p-1.5 rounded-xl border flex items-center gap-1 font-semibold transition-all ${
                  logPage === 1
                    ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                    : "bg-white text-gray-700 border-gray-200 hover:bg-teal-50 hover:text-teal-600 hover:border-teal-200"
                }`}
              >
                <FiChevronLeft className="w-4 h-4" />
              </button>
              <button
                onClick={() => setLogPage((p) => p + 1)}
                disabled={paginate(filteredLogs, logPage + 1).length === 0}
                className={`p-1.5 rounded-xl border flex items-center gap-1 font-semibold transition-all ${
                  paginate(filteredLogs, logPage + 1).length === 0
                    ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                    : "bg-white text-gray-700 border-gray-200 hover:bg-teal-50 hover:text-teal-600 hover:border-teal-200"
                }`}
              >
                <FiChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Log Mutasi Obat */}
        <div className="bg-white rounded-3xl p-6 shadow-xl shadow-gray-200/50 border border-gray-100/80 flex flex-col justify-between">
          <div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
              <div className="flex items-center gap-2.5">
                <div className="p-2.5 rounded-2xl bg-teal-50 text-teal-600 border border-teal-100">
                  <FiLayers className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">
                    Log Mutasi Obat
                  </h3>
                  <p className="text-xs text-gray-400">Riwayat perubahan stok obat</p>
                </div>
              </div>

              {/* Live Search Log Obat */}
              <div className="relative">
                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Cari obat/log..."
                  value={logObatSearch}
                  onChange={(e) => {
                    setLogObatSearch(e.target.value);
                    setLogObatPage(1);
                  }}
                  className="pl-9 pr-3 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-xs text-gray-800 focus:outline-none focus:ring-2 focus:ring-teal-500/20 focus:border-teal-500 w-full sm:w-44 transition-all"
                />
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left text-xs text-gray-600">
                <thead>
                  <tr className="border-b border-gray-100 text-gray-400 font-bold uppercase tracking-wider text-[10px]">
                    <th className="pb-3 px-2">Waktu</th>
                    <th className="pb-3 px-2">Nama Obat</th>
                    <th className="pb-3 px-2">Qty</th>
                    <th className="pb-3 px-2">Catatan</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {paginate(filteredLogObat, logObatPage).length === 0 ? (
                    <tr>
                      <td
                        colSpan={4}
                        className="py-8 text-center text-gray-400 text-xs font-medium"
                      >
                        Tidak ada log mutasi obat ditemukan
                      </td>
                    </tr>
                  ) : (
                    paginate(filteredLogObat, logObatPage).map((log) => (
                      <tr
                        key={log.id}
                        className="hover:bg-teal-50/40 transition-colors"
                      >
                        <td className="py-3 px-2 text-gray-500 whitespace-nowrap">
                          {new Date(log.log_at).toLocaleString("id-ID", {
                            day: "2-digit",
                            month: "short",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                        <td className="py-3 px-2 font-bold text-gray-800 whitespace-nowrap">
                          {log.obat?.name || "-"}
                        </td>
                        <td className="py-3 px-2">
                          <span
                            className={`inline-flex px-2 py-0.5 rounded-lg text-xs font-extrabold ${
                              log.qty > 0
                                ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                                : "bg-rose-50 text-rose-700 border border-rose-200"
                            }`}
                          >
                            {log.qty > 0 ? `+${log.qty}` : log.qty}
                          </span>
                        </td>
                        <td className="py-3 px-2 text-gray-700 max-w-xs truncate">
                          {log.message}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination Log Obat */}
          <div className="flex items-center justify-between mt-6 pt-4 border-t border-gray-100 text-xs">
            <span className="text-gray-400">Halaman {logObatPage}</span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setLogObatPage((p) => Math.max(p - 1, 1))}
                disabled={logObatPage === 1}
                className={`p-1.5 rounded-xl border flex items-center gap-1 font-semibold transition-all ${
                  logObatPage === 1
                    ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                    : "bg-white text-gray-700 border-gray-200 hover:bg-teal-50 hover:text-teal-600 hover:border-teal-200"
                }`}
              >
                <FiChevronLeft className="w-4 h-4" />
              </button>
              <button
                onClick={() => setLogObatPage((p) => p + 1)}
                disabled={paginate(filteredLogObat, logObatPage + 1).length === 0}
                className={`p-1.5 rounded-xl border flex items-center gap-1 font-semibold transition-all ${
                  paginate(filteredLogObat, logObatPage + 1).length === 0
                    ? "bg-gray-100 text-gray-300 border-gray-200 cursor-not-allowed"
                    : "bg-white text-gray-700 border-gray-200 hover:bg-teal-50 hover:text-teal-600 hover:border-teal-200"
                }`}
              >
                <FiChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default DashboardPage;
